{
  "version": 1,
  "asset_id": "bc28380a-243e-4c21-b85b-04b88729e09f",
  "project_id": "d4069efb-83f9-479f-9707-e712fc5f9875",
  "url": "/__l5e/assets-v1/bc28380a-243e-4c21-b85b-04b88729e09f/nieuwbouw-1024.avif",
  "r2_key": "a/v1/d4069efb-83f9-479f-9707-e712fc5f9875/bc28380a-243e-4c21-b85b-04b88729e09f/nieuwbouw-1024.avif",
  "original_filename": "nieuwbouw-1024.avif",
  "size": 44637,
  "content_type": "image/avif",
  "created_at": "2026-10-18T17:03:33Z"
}
